module.exports = __webpack_public_path__ + "static/media/W09F2000.e055dd83.svg";